/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFTechSourceType = {
    Firehose: 'firehose',
    Asm: 'asm'
} as const;
export type CRSFTechSourceType = typeof CRSFTechSourceType[keyof typeof CRSFTechSourceType];


export function CRSFTechSourceTypeFromJSON(json: any): CRSFTechSourceType {
    return CRSFTechSourceTypeFromJSONTyped(json, false);
}

export function CRSFTechSourceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFTechSourceType {
    return json as CRSFTechSourceType;
}

export function CRSFTechSourceTypeToJSON(value?: CRSFTechSourceType | null): any {
    return value as any;
}

